import { clsx } from "clsx";
import { snakeCase } from "lodash";
import PropTypes from "prop-types";
import { useContext } from "react";
import { Link, useLocation, useMatch } from "react-router-dom";
import VerticalDivider from "../../../components/VerticalDivider";
import Authorization from "../../../enhancers/Authorization";
import { PAGE_PATH } from "../../../path";
import { settings } from "../../../shim/jsbridge";
import LicenseValidChecker from "../../licensing/containers/LicenseValidChecker";
import QuotaUsage from "../../quota-usage/QuotaUsage";
import HeaderAlerts from "../alerts/HeaderAlerts";
import { ResetSearchContext } from "../context";
import {
  getNavigationRoutes,
  RL_NAVIGATION_ITEM_LABELS
} from "../header.routes";
import SystemHealth from "../system-health/SystemHealth";
import RlNavigationHelpItem from "./RlNavigationHelpItem";
import RlNavigationUserItem from "./RlNavigationUserItem";
import RiskToleranceLevelIndicator from "./RiskToleranceLevelIndicator";
import RlNavigationItem from "./components/RlNavigationItem";
import { getYaraPageReload } from "./utils";

const RlNavigation = ({ user, linksReloadDocumentOverride }) => {
  const { pathname, search: urlParams } = useLocation();
  const { FEATURE_ALERTFEED } = settings || {};
  const { triggerSearchReset } = useContext(ResetSearchContext);

  const viewingUrlPage = useMatch(PAGE_PATH.URL);

  const navigationItems = getNavigationRoutes(!!viewingUrlPage);

  return (
    <nav className="main-nav__container" data-testid="main_nav_container">
      <LicenseValidChecker>
        {navigationItems
          .filter(item => item.visible)
          .map(item => (
            <Authorization
              key={item.label}
              allowedPermissions={item.allowedPermissions}
            >
              <RlNavigationItem
                className={clsx(item.additionalClassName, {
                  "main-nav__item--active":
                    pathname === PAGE_PATH.YARA
                      ? item.url.includes(pathname)
                      : pathname === item.url
                })}
                testId={snakeCase(`main_nav_menu_item_${item.label}`)}
              >
                <Link
                  to={item.url}
                  reloadDocument={
                    item.linkReloadsDocument ||
                    linksReloadDocumentOverride ||
                    getYaraPageReload(item.label, pathname, urlParams)
                  }
                  onClick={
                    item.label === RL_NAVIGATION_ITEM_LABELS.SEARCH
                      ? () => {
                          triggerSearchReset();
                        }
                      : undefined
                  }
                  className="main-nav__item-link"
                >
                  {item.displayLabel || item.label}
                </Link>
              </RlNavigationItem>
            </Authorization>
          ))}
        <RlNavigationHelpItem />

        <VerticalDivider color="black" />
        <QuotaUsage />
        {FEATURE_ALERTFEED && (
          <HeaderAlerts linksReloadDocument={linksReloadDocumentOverride} />
        )}
        <SystemHealth />
      </LicenseValidChecker>
      <RlNavigationUserItem
        user={user}
        linksReloadDocumentOverride={linksReloadDocumentOverride}
      />
      <RiskToleranceLevelIndicator />
    </nav>
  );
};

RlNavigation.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string,
    isAdmin: PropTypes.bool
  }),
  linksReloadDocumentOverride: PropTypes.bool
};

export default RlNavigation;
